export default __webpack_public_path__ + "static/media/767.295ac855.gif";